import { UnavailableProductPopup, SimpleUpsale, SimpleUpsaleSpecial, MultiUpsale } from '../type';
import { ProductDetails } from 'core/store/billing/selectors';

export interface RemoteConfigUpsales {
  unavailableProduct: string[];
  meditationEbookContent: any;
  pregnancyEbookContent: any;
  upsaleFlowMode: boolean;
  upsaleFlow: string[];
  isUpsaleSingleProduct: boolean;

  upsaleSteps: {};
  isShow1clickTestBtn: boolean;
  upsaleFullAiMasterPack: SimpleUpsale & SimpleUpsale[];
  upsaleFullAiMasterPackSpecial: SimpleUpsaleSpecial & SimpleUpsaleSpecial[];
  upsaleAiSideHustlePlan: SimpleUpsale & SimpleUpsale[];
  upsaleAiSideHustlePlanSpecial: SimpleUpsaleSpecial & SimpleUpsaleSpecial[];
  upsaleProducts: Record<string, ProductDetails[]>;
  upsaleMulti: MultiUpsale;
  upsaleMultiSpecial: MultiUpsale;
  upsaleUltraPack: SimpleUpsale;
  upsaleUltraPackSpecial: SimpleUpsaleSpecial;
  upsaleRareIntelligencePlan: SimpleUpsale;
  upsaleRareIntelligencePlanSpecial: SimpleUpsaleSpecial;
  upsaleIGFollowersPack: SimpleUpsale;
  upsaleIGFollowersPackSpecial: SimpleUpsale;
  upsaleIGGrowthCourse: SimpleUpsale;
  upsaleIGGrowthCourseSpecial: SimpleUpsale;
}

export const INITIAL_CONFIG_UPSALES: RemoteConfigUpsales = {
  unavailableProduct: [],
  pregnancyEbookContent: {},
  meditationEbookContent: {},

  upsaleFlowMode: false,
  upsaleFlow: [],
  isUpsaleSingleProduct: true,
  upsaleSteps: {},
  isShow1clickTestBtn: false,
  upsaleFullAiMasterPack: {} as SimpleUpsale & SimpleUpsale[],
  upsaleFullAiMasterPackSpecial: {} as SimpleUpsaleSpecial & SimpleUpsaleSpecial[],
  upsaleAiSideHustlePlan: {} as SimpleUpsale & SimpleUpsale[],
  upsaleAiSideHustlePlanSpecial: {} as SimpleUpsaleSpecial & SimpleUpsaleSpecial[],
  upsaleProducts: {},
  upsaleMulti: {} as MultiUpsale,
  upsaleMultiSpecial: {} as MultiUpsale,
  upsaleUltraPack: {} as SimpleUpsale,
  upsaleUltraPackSpecial: {} as SimpleUpsaleSpecial,
  upsaleRareIntelligencePlan: {} as SimpleUpsale,
  upsaleRareIntelligencePlanSpecial: {} as SimpleUpsaleSpecial,
  upsaleIGFollowersPack: {} as SimpleUpsale,
  upsaleIGFollowersPackSpecial: {} as SimpleUpsale,
  upsaleIGGrowthCourse: {} as SimpleUpsale,
  upsaleIGGrowthCourseSpecial: {} as SimpleUpsale,
};
